import React from 'react';
import styled from 'styled-components';

const StatusContainer = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.textSecondary || '#888'};
  margin-top: 4px;
  margin-left: auto;
  text-align: right;
  padding-right: 8px;
  font-style: italic;
`;

const QueueStatus = ({ isQueued }) => {
  if (!isQueued) return null;
  
  return (
    <StatusContainer>
      Đang gửi...
    </StatusContainer>
  );
};

export default QueueStatus;
